import { v4 as uuid } from 'uuid';

const env =
  typeof import.meta.env.VITE_REACT_APP_ENV === 'undefined'
    ? 'local'
    : import.meta.env.VITE_REACT_APP_ENV;

export const TransactionId = uuid();

interface IConfig {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  local: string;
  dev: string;
  prod: string;
}
interface IConfigCat {
  configCatKey: string;
}

const config: { [key: string]: IConfigCat } = {
  dev: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/IPESsOqktUCQD6D5_yEoPQ',
  },
  'dev-blue': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/IPESsOqktUCQD6D5_yEoPQ',
  },
  'dev-green': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/IPESsOqktUCQD6D5_yEoPQ',
  },
  qa: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/feIOrSc1vkGNzL9PqOZlBA',
  },
  'qa-blue': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/feIOrSc1vkGNzL9PqOZlBA',
  },
  'qa-green': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/feIOrSc1vkGNzL9PqOZlBA',
  },
  training: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/N8YZWAoKt0uBAiZXGLJgPw',
  },
  'training-blue': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/N8YZWAoKt0uBAiZXGLJgPw',
  },
  'training-green': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/N8YZWAoKt0uBAiZXGLJgPw',
  },
  prod: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/hjnJf4_SFEqDij0CJOOezQ',
  },
  'prod-blue': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/hjnJf4_SFEqDij0CJOOezQ',
  },
  'prod-green': {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/hjnJf4_SFEqDij0CJOOezQ',
  },
  dev2: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/kOB9hQiaiEetF8M8o6SoWQ',
  },
  qa2: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/lnGRBUiU2UCQ0b1dz8rmSA',
  },
  uat: {
    configCatKey: 'VXnaCPwZl0mLgqU9kv1rJQ/JaHSo2a1Y0OColWFQj1FZQ',
  },
};

const cognitoDomain: IConfig = {
  env,
  local: 'aims-dev.auth.us-east-2.amazoncognito.com',
  dev: 'aims-dev.auth.us-east-2.amazoncognito.com',
  'dev-blue': 'aims-dev.auth.us-east-2.amazoncognito.com',
  'dev-green': 'aims-dev.auth.us-east-2.amazoncognito.com',
  dev2: 'aims-dev.auth.us-east-2.amazoncognito.com',
  qa: 'aims-dev.auth.us-east-2.amazoncognito.com',
  'qa-blue': 'aims-dev.auth.us-east-2.amazoncognito.com',
  'qa-green': 'aims-dev.auth.us-east-2.amazoncognito.com',
  qa2: 'aims-dev.auth.us-east-2.amazoncognito.com',
  uat: 'aims-dev.auth.us-east-2.amazoncognito.com',
  prod: 'aims-prod.auth.us-east-2.amazoncognito.com',
  'prod-blue': 'aims-prod.auth.us-east-2.amazoncognito.com',
  'prod-green': 'aims-prod.auth.us-east-2.amazoncognito.com',
  training: 'aims-staging.auth.us-east-2.amazoncognito.com',
  'training-blue': 'aims-staging.auth.us-east-2.amazoncognito.com',
  'training-green': 'aims-staging.auth.us-east-2.amazoncognito.com',
};

const providers = {
  office365IdentityProvider: 'eaoperations-aims',
};

const office365IdentityProviderName: IConfig = {
  env,
  local: providers.office365IdentityProvider,
  dev: providers.office365IdentityProvider,
  'dev-blue': providers.office365IdentityProvider,
  'dev-green': providers.office365IdentityProvider,
  dev2: providers.office365IdentityProvider,
  qa: providers.office365IdentityProvider,
  'qa-blue': providers.office365IdentityProvider,
  'qa-green': providers.office365IdentityProvider,
  qa2: providers.office365IdentityProvider,
  uat: providers.office365IdentityProvider,
  prod: providers.office365IdentityProvider,
  'prod-blue': providers.office365IdentityProvider,
  'prod-green': providers.office365IdentityProvider,
  training: providers.office365IdentityProvider,
  'training-blue': providers.office365IdentityProvider,
  'training-green': providers.office365IdentityProvider,
};

const cognitoIdentityPool: IConfig = {
  env,
  local: 'us-east-2:1d701e83-37e8-4d6a-9cdf-e419f1f17570',
  dev: 'us-east-2:1d701e83-37e8-4d6a-9cdf-e419f1f17570',
  'dev-blue': 'us-east-2:1d701e83-37e8-4d6a-9cdf-e419f1f17570',
  'dev-green': 'us-east-2:1d701e83-37e8-4d6a-9cdf-e419f1f17570',
  dev2: 'us-east-2:5c26ee51-e4b9-4608-96b8-c96123b2479f',
  qa: 'us-east-2:67cfae6f-3c44-446d-88c3-5767b03a7a50',
  'qa-blue': 'us-east-2:67cfae6f-3c44-446d-88c3-5767b03a7a50',
  'qa-green': 'us-east-2:67cfae6f-3c44-446d-88c3-5767b03a7a50',
  qa2: 'us-east-2:96bd8af9-feb9-4401-921e-bc4ed254266c',
  uat: 'us-east-2:74b5a2d6-5035-45de-8a76-b8fee931843c',
  prod: 'us-east-2:baa3f821-3055-4d55-8773-2ddd9a8d66f8',
  'prod-blue': 'us-east-2:baa3f821-3055-4d55-8773-2ddd9a8d66f8',
  'prod-green': 'us-east-2:baa3f821-3055-4d55-8773-2ddd9a8d66f8',
  training: 'us-east-2:73a3f624-46a2-4cb1-9100-7c87967bf864',
  'training-blue': 'us-east-2:73a3f624-46a2-4cb1-9100-7c87967bf864',
  'training-green': 'us-east-2:73a3f624-46a2-4cb1-9100-7c87967bf864',
};

const cognitoUserPool: IConfig = {
  env,
  local: 'us-east-2_5wpdEu741',
  dev: 'us-east-2_5wpdEu741',
  'dev-blue': 'us-east-2_5wpdEu741',
  'dev-green': 'us-east-2_5wpdEu741',
  dev2: 'us-east-2_5wpdEu741',
  qa: 'us-east-2_5wpdEu741',
  'qa-blue': 'us-east-2_5wpdEu741',
  'qa-green': 'us-east-2_5wpdEu741',
  qa2: 'us-east-2_5wpdEu741',
  uat: 'us-east-2_5wpdEu741',
  prod: 'us-east-2_nbOQnor4y',
  'prod-blue': 'us-east-2_nbOQnor4y',
  'prod-green': 'us-east-2_nbOQnor4y',
  training: 'us-east-2_BQ5VgU8lk',
  'training-blue': 'us-east-2_BQ5VgU8lk',
  'training-green': 'us-east-2_BQ5VgU8lk',
};

const cognitoWebClientId: IConfig = {
  env,
  local: '6er94n4d9upqad3hfuetmrkpht',
  dev: '6er94n4d9upqad3hfuetmrkpht',
  'dev-blue': '6er94n4d9upqad3hfuetmrkpht',
  'dev-green': '6er94n4d9upqad3hfuetmrkpht',
  dev2: '4bued1tnp8r70udl77nkb9c5hs',
  qa: '2bcnohtfhpsdjacqhffo4v0t6o',
  'qa-blue': '2bcnohtfhpsdjacqhffo4v0t6o',
  'qa-green': '2bcnohtfhpsdjacqhffo4v0t6o',
  qa2: '6icbsmq5057glhtf0g7hkebk3n',
  uat: '7bmaaobhj5mt9s46hq8rjjjepo',
  prod: 't0vidaoe4qs2ik25cuc7q3i39',
  'prod-blue': 't0vidaoe4qs2ik25cuc7q3i39',
  'prod-green': 't0vidaoe4qs2ik25cuc7q3i39',
  training: '4nub1h1emg3g06bbjh9nanh2rm',
  'training-blue': '4nub1h1emg3g06bbjh9nanh2rm',
  'training-green': '4nub1h1emg3g06bbjh9nanh2rm',
};

const bucketName: IConfig = {
  env,
  local: 'eaoperations-aims-files-dev',
  dev: 'eaoperations-aims-files-dev',
  'dev-blue': 'eaoperations-aims-files-dev',
  'dev-green': 'eaoperations-aims-files-dev',
  dev2: 'eaoperations-aims-files-dev2',
  qa: 'eaoperations-aims-files-qa',
  'qa-blue': 'eaoperations-aims-files-qa',
  'qa-green': 'eaoperations-aims-files-qa',
  qa2: 'eaoperations-aims-files-qa2',
  uat: 'eaoperations-aims-files-uat',
  prod: 'eaoperations-aims-files',
  'prod-blue': 'eaoperations-aims-files',
  'prod-green': 'eaoperations-aims-files',
  training: 'eaoperations-aims-files-training',
  'training-blue': 'eaoperations-aims-files-training',
  'training-green': 'eaoperations-aims-files-training',
};

const kinesisStreamName: IConfig = {
  env,
  local: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  dev: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  'dev-blue': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  'dev-green': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  dev2: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  qa: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  'qa-blue': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  'qa-green': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  qa2: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  uat: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1Q5IOOX1ADUEN',
  prod: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
  'prod-blue': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
  'prod-green': 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
  training: 'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
  'training-blue':
    'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
  'training-green':
    'GenericErrorLoggingInfrastructureStack-ErrorLoggingStreamB61F73B1-1X344LX3GYG9A',
};

function getRedirectUrl() {
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${window.location.hostname}${port}/`;
}

const appConfig = {
  aws_project_region: 'us-east-2', // same for all environments
  aws_cognito_identity_pool_id: cognitoIdentityPool[env ? env : 'local'],
  aws_cognito_region: 'us-east-2', // same for all environments
  aws_user_pools_id: cognitoUserPool[env ? env : 'local'],
  aws_user_pools_web_client_id: cognitoWebClientId[env ? env : 'local'],
  Auth: {
    adfsFederatedIdentityProviderId: office365IdentityProviderName[env ? env : 'local'],
    region: 'us-east-2', // same for all environments
    userPoolWebClientId: cognitoWebClientId[env ? env : 'local'],
    userPoolId: cognitoUserPool[env ? env : 'local'],
    identityPoolId: cognitoIdentityPool[env ? env : 'local'],
    oauth: {
      office365IdentityProvider: office365IdentityProviderName[env ? env : 'local'],
      domain: cognitoDomain[env ? env : 'local'],
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: getRedirectUrl(),
      redirectSignOut: getRedirectUrl(),
      responseType: 'code',
    },
  },
  Storage: {
    AWSS3: {
      bucket: bucketName[env ? env : 'local'],
      region: 'us-east-2',
    },
  },
  kinesisStreamName: kinesisStreamName[env ? env : 'local'],
  logLevel: 'INFO',
  config: config[env] ?? config.dev2,
};

export default appConfig;
